"use client";
import { fitSearchModeStore } from "@/components/search/_utils/searchStore";
import { useEffect } from "react";

export const FitSearchMode = () => {
  useEffect(() => {
    fitSearchModeStore.set(true);
    return () => fitSearchModeStore.set(false);
  }, []);

  return null;
};
